import { GET_COMPANY_SUCCESS, GET_COMPANY_FAILURE, GET_COMPANY_REQUEST, GET_PROFILE_SUCCESS, GET_PROFILE_FAILURE, GET_PROFILE_REQUEST } from "./otherActions";


const initialState = {
    loading: false,
    error: null,
    companies: [],
    profiles: []
}

const otherReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_COMPANY_REQUEST:
            return { ...state, loading: true, error: null }
        case GET_COMPANY_SUCCESS:
            return { ...state, loading: false, error: null, companies: action.payload }
        case GET_COMPANY_FAILURE:
            return { ...state, loading: false, error: action.payload }

        case GET_PROFILE_REQUEST:
            return { ...state, loading: true, error: null }
        case GET_PROFILE_SUCCESS:
            return { ...state, loading: false, error: null, profiles: action.payload }
        case GET_PROFILE_FAILURE:
            return { ...state, loading: false, error: action.payload }
        default:
            return state
    }
}

export default otherReducer